import {
  NotificationSkillState,
  NotificationState,
} from "@/domains/notification/constants/notificationState";

export default function isSkillNotification(
  notification: NotificationState,
): notification is NotificationSkillState {
  return (notification as NotificationSkillState).skill !== undefined;
}
